import {
  collection, doc, addDoc, updateDoc, deleteDoc, increment,
  query, where, orderBy, onSnapshot, serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { applyRoleFilter, getOwnershipFields } from './dataFilterHelper';

const COLLECTION = 'clients';

// ======== CRIAR CLIENTE ========
export const createClient = async (userId, data, profile) => {
  const ownership = profile ? getOwnershipFields(profile) : { userId, masterId: userId, gestorId: userId };
  return addDoc(collection(db, COLLECTION), {
    ...data,
    ...ownership,
    stage: data.stage || 'novo',
    status: 'active',
    simulacoes: 0,
    criadoEm: serverTimestamp(),
    atualizadoEm: serverTimestamp(),
  });
};

// ======== LISTAR CLIENTES (com filtro por role) ========
export const subscribeClientsByRole = (profile, callback) => {
  const baseQuery = query(collection(db, COLLECTION), orderBy('criadoEm', 'desc'));
  const filtered = applyRoleFilter(baseQuery, profile);
  return onSnapshot(filtered, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

// Versão legada (por userId) — mantida para compatibilidade
export const subscribeClients = (userId, callback) => {
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId),
    orderBy('criadoEm', 'desc')
  );
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

// ======== ATUALIZAR CLIENTE ========
export const updateClient = async (clientId, data) => {
  return updateDoc(doc(db, COLLECTION, clientId), {
    ...data,
    atualizadoEm: serverTimestamp(),
  });
};

// ======== EXCLUIR CLIENTE ========
export const deleteClient = async (clientId) => {
  return deleteDoc(doc(db, COLLECTION, clientId));
};

// ======== ATUALIZAR APÓS SIMULAÇÃO ========
export const updateClientAfterSimulation = async (clientId, simData) => {
  return updateDoc(doc(db, COLLECTION, clientId), {
    ultimaSimulacao: simData,
    melhorBanco: simData.melhorBanco,
    simulacoes: increment(1),
    atualizadoEm: serverTimestamp(),
  });
};